// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._7uyb9{width:100vw;margin:24px -16px 32px}@media screen and (min-width:768px){._7uyb9{width:100%;margin:40px 0;border-radius:8px}}[data-a11y] ._7uyb9{margin-top:48px;margin-bottom:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxGallery": "_7uyb9"
};
module.exports = ___CSS_LOADER_EXPORT___;
